import { render, staticRenderFns } from "./jiatingzhuzhi.vue?vue&type=template&id=11638c85&scoped=true&"
import script from "./jiatingzhuzhi.vue?vue&type=script&lang=ts&"
export * from "./jiatingzhuzhi.vue?vue&type=script&lang=ts&"
import style0 from "./jiatingzhuzhi.vue?vue&type=style&index=0&id=11638c85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11638c85",
  null
  
)

export default component.exports